import styled from 'styled-components';
import { motion } from 'framer-motion';

import { TextAreaContainer } from '../MessageFields/MessageFields.styles';

export const Content = styled(motion.div)`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${TextAreaContainer} {
    background-color: var(--color-white);
  }
`;
